/* eslint-disable camelcase */
// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import moment from 'moment'
import DataUtils from '@/utils/DataUtils'
import ConfirmDialogPreset from '@/components/autoImport/ConfirmDialogPreset'

const C11101T3010ChatroomCheckModule = {
  state: {
    C11101_t3010ChatroomCheck_output: {
      rows: []
    },
  },
  getters: {
    C11101_t3010ChatroomCheck_getData(state) {
      return state.c1101Table_lessons.map(item => {
        return {
          rel_id: item.id
        }
      })
    },
    C11101_t3010ChatroomCheck_getMessageCount: (state) => (id) => {
      if(!state.C11101_t3010ChatroomCheck_output.rows || !Array.isArray(state.C11101_t3010ChatroomCheck_output.rows)) {
        return 0;
      }
      const item = state.C11101_t3010ChatroomCheck_output.rows.find(item => item.rel_id === id);
      if (item)
        return item.message_count || 0;

      return 0;
    }
  },
  actions: {
  }
}

const C11101StudentJoinCheckModule={
  state: {
    C11101_StudentJoinCheck_output: [],
  },
  getters: {
  },
  actions: {
  }

}

const C11101T2050Module = {
  state:{
    C11101T2050_rows: [],
    C11101T2050_map: {},
  },
  getters:{
    C11101T2050_isWorkCell: (state) => ({
      schedule_date,
      time_limit_no,
      teacher_no
    }) => {
      return !!state.C11101T2050_map[`${schedule_date}_${time_limit_no}_${teacher_no}`];
    },
    C11101T2050_isWorkCell_content: (state,getters) => ({
      schedule_date,
      time_limit_no,
      teacher_no,
      capacity
    }) => {
      const result = getters.C11101T2050_isWorkCell({
        schedule_date,
        time_limit_no,
        teacher_no
      });
      if(result){
        return capacity === 1 ? '事務作業' : '↑'
      }
    },
    C11101T2050_submitApi: (state) => {
      return {
        api: 'T2050OthersScheduleService.C11101T2050_submit',
        input: {
          start_date: state.searchInfo.date[0],
          end_date: state.searchInfo.date[1],
          center_no: state.searchInfo.center,
          rows: state.C11101T2050_rows
        }
      }
    }
  },
  mutations: {
    set_C11101T2050_map: (state) => {
      const output = {};
      state.C11101T2050_rows.forEach(t2050 => {
        const key = `${t2050.schedule_date}_${t2050.time_limit_no}_${t2050.teacher_no}`;
        if(t2050._action === 'delete') return; // skip delete action
        output[key] = true;
      });
      state.C11101T2050_map = Object.freeze(output);
    },
  },
  actions:{
    async C11101T2050_setWork({ state, commit },{
      schedule_date,
      time_limit_no,
      teacher_no,
      timeGroup,
      timeLimit
    }){
      if (!schedule_date) throw new Error('schedule_date is required');
      if (!time_limit_no) throw new Error('time_limit_no is required');
      if (!teacher_no) throw new Error('teacher_no is required');
      const key = `${schedule_date}_${time_limit_no}_${teacher_no}`;

      console.debug('C11101T2050_setWork', {
        schedule_date,
        time_limit_no,
        teacher_no,
        timeGroup,
        timeLimit
      })

      const exist = state.C11101T2050_map[key];

      const ok = await window.vue.$confirm({
        ...ConfirmDialogPreset.baseConfirm,
        text: `${timeLimit.time_limit_name}を事務作業で登録します。よろしいですか？\n（事務作業の取り消しは、担当者へ連絡してください。）`,
      })
      if (!ok) {
        return;
      }


      const res = await ApiUtils.postData({
        data: [
          {
            api: 'T2050OthersScheduleService.C11101T2050_setWork',
            input: {
              schedule_date,
              time_limit_no,
              teacher_no
            }
          },
        ]
      })

      console.debug({
        res,
        key,
        exist
      })
      if (exist) {
        const row = state.C11101T2050_rows.find(r => r.schedule_date === schedule_date && r.time_limit_no === time_limit_no && r.teacher_no === teacher_no);
        const index = state.C11101T2050_rows.indexOf(row);
        state.C11101T2050_rows[index]._action = 'delete'
      } else{
        const newRow = {
          schedule_date,
          time_limit_no,
          teacher_no,
          timeDivision: time_limit_no % 10,
        }
        state.C11101T2050_rows.push(newRow);
      }
      commit('set_C11101T2050_map')
      window.vue.$dialog.notify.success('事務作業を登録しました。');
    }

  }
}


const module = {
  state: {
    initInfo: {
      teacher_no: null,
      center_no:9,
      date: moment().format('YYYY-MM-DD'),
    },
    section1Data:{
      outstanding_lesson_report: 0,
      resubmitted_lesson_report_required: 0
    },
    section2Data:{
      start_time: null
    },
    renderKey: 0,

    c1101Table_timeSlots: [],
    c1101Table_teachers: [],
    c1101Table_lessons: [],
    main_t2030_teacher_schedule: [],

    C11101Image_lessonInfo: [],
    C11101Image_avilableSubject: [],
  },

  getters: {
    isAttendanceConfirmed (state) {
      return state.section2Data.start_time !== '00:00'
    },
  },

  mutations: {
    SET_INIT_INFO (state, payload) {
      state.initInfo = payload
    },
    SET_RENDER_KEY (state) {
      state.renderKey = DataUtils.randomString(10)
    }
  },
  actions: {
    async C11101Image_fetch({ commit }, payload) {
      const res = await ApiUtils.postData({
        data: {
          imageLessonInfo: {
            api: 'T2010TeacherBasicService.C11101_getImageLessonInfo',
            input: payload
          }
        }
      })
      commit('setState', {
        C11101Image_lessonInfo: res.imageLessonInfo.output.lessonInfo,
        C11101Image_avilableSubject: res.imageLessonInfo.output.avilableSubject,
      })
    },
    async fetchInitInfo ({ commit, state }) {
      const res = await ApiUtils.postData({
        data:
        {
          init: {
            api: 'T2040TeacherScheduleService.C11101_initData',
            input: {
              teacher_no:state.initInfo.teacher_no,
              schedule_date:state.initInfo.date
            }
          },
          confirmTeacherAttendance:{
            api: 'T3120TeacherReportingService.C11101_getTeacherReporting',
            input: {
              teacher_no: state.initInfo.teacher_no,
              schedule_date: state.initInfo.date,
            },
          },
        }
      })
      commit('setState', {
        section1Data: res.init.output.section1Data,
        section2Data: res.confirmTeacherAttendance.output,
      })
    },
    async C11101Table_fetch({ state,commit },payload){
      const res = await ApiUtils.postData({
        data: {
          c1101Table_timeSlots:{
            api: 'T0050CalendarService.C11101_getCalendar',
            input: {
              start_date: state.initInfo.date,
              end_date: state.initInfo.date,
              teacher_no: state.initInfo.teacher_no,
            }
          },
          c1101Table_teachers:{
            api: 'T2010TeacherBasicService.C11101_getTeacherInfoAndSchedule',
            input: {
              start_date: state.initInfo.date,
              end_date: state.initInfo.date,
              teacher_no: state.initInfo.teacher_no,
            }
          },
          c1101Table_lessons:{
            api: 'T2010TeacherBasicService.C11101_getAppliedSchedule',
            input: {
              start_date: state.initInfo.date,
              end_date: state.initInfo.date,
              teacher_no: state.initInfo.teacher_no,
            }
          },
          main_t2030_teacher_schedule: {
            api: 'T2040TeacherScheduleService.C11101_getTeacherSchedule',
            input: {
              start_date: state.initInfo.date,
              end_date: state.initInfo.date,
              teacher_no: state.initInfo.teacher_no
            }
          },
          C11101T2050_rows:{
            api: 'T2050OthersScheduleService.C11101T2050_init',
            input: {
              start_date: state.initInfo.date,
              end_date: state.initInfo.date,
              teacher_no: state.initInfo.teacher_no,
            }
          }
        }
      })
      commit('setState',{
        renderKey : DataUtils.randomString(10),
        c1101Table_timeSlots: res.c1101Table_timeSlots.output,
        c1101Table_teachers: res.c1101Table_teachers.output,
        c1101Table_lessons: res.c1101Table_lessons.output,
        main_t2030_teacher_schedule: res.main_t2030_teacher_schedule.output,
        C11101T2050_rows: res.C11101T2050_rows.output,
      })

      commit('set_C11101T2050_map')
    },
  }
}

export default ObjArrUtils.merge(Base, module,C11101T3010ChatroomCheckModule,C11101T2050Module,C11101StudentJoinCheckModule)
